export const environment = {
    production: true,
    isDeployChangesEnabled: false,
    apiUrl: 'https://api.staging.portal.joynd.io/api',
    baseUrl: 'https://api.staging.portal.joynd.io'
};
